import styled from '@emotion/styled';
import { forwardRef, useEffect, useState } from 'react';

import { Copyright } from '@features';
import { ReactComponent as Logo } from '@icons/excorp-logo.svg';
import { ifProp } from '@lib/ifProp';
import { getMediaqueryStyled } from '@styles/mixins/mediaqueries';
import { useMediaQuery } from '@utils/hooks/useMediaQuery';
import { getMediaqueryDual } from '@utils/utils';

// eslint-disable-next-line no-empty-pattern
export const Header = forwardRef<HTMLDivElement>(({}, ref) => {
  const [lastScroll, setLastScroll] = useState(0);
  const [isScrollDown, setIsScrollDown] = useState(false);

  const isMobile = useMediaQuery(getMediaqueryDual('mobile'));

  useEffect(() => {
    const listenScrollEvent = () => {
      const currentScroll = window.scrollY;

      if (currentScroll === 0) {
        setIsScrollDown(false);
        return;
      }

      if (currentScroll > lastScroll) {
        setIsScrollDown(true);
      } else if (currentScroll < lastScroll) {
        setIsScrollDown(false);
      }

      setLastScroll(currentScroll);
    };

    window.addEventListener('scroll', listenScrollEvent);

    return () => window.removeEventListener('scroll', listenScrollEvent);
  }, [lastScroll]);

  if (isMobile) {
    return (
      <Wrapper isDown={isScrollDown} ref={ref}>
        <StyledLogo />
        <StyledCopyright />
      </Wrapper>
    );
  }

  return null;
});

interface WrapperProps {
  isDown?: boolean;
}

const Wrapper = styled.header<WrapperProps>`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 25;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 140px;
  padding: 45px 25px;
  background-color: var(--colors-gray);
  transform: ${ifProp('isDown', 'translateY(-100%)', 'translateY(0)')};
  transition: transform var(--duration-long) ease-in;
  will-change: transform;

  ${getMediaqueryStyled('sm')} {
    flex-direction: column;
    padding: 22px 140px;
  }
`;

const StyledLogo = styled(Logo)`
  width: 49px;
  height: 49px;
`;

const StyledCopyright = styled(Copyright)`
  ${getMediaqueryStyled('sm')} {
    max-width: 90px;
  }
`;
